<template>
  <div v-if="showChannel">
    <div class="social-title">Official Channels</div>
    <a v-if="socialItem.url" :href="socialItem.url"
        v-for="(socialItem, key) in socialItems"
        :key="key"
        v-gtm-tracker="{ec: 'Outbound Clicks', ea: 'China Tech City Overlay/Offical Channels/Click', el: key}"
        >
      <img :src="socialItem.icon" :alt="key"/>
    </a>
    <a v-if="companyUrl" :href="companyUrl.url" class="company-url" target="_blank" v-gtm-tracker="{ec: 'Outbound Clicks', ea: 'China Tech City Overlay/Offical Channels/Click', el: 'Company URL'}">
      <svg-link-icon class="icon"></svg-link-icon>{{companyUrl.processedUrl}}
    </a>
  </div>
</template>

<script>
  import reduce from 'lodash/reduce'
  import get from 'lodash/get'
  import SvgLinkIcon from 'static/svg/icon_link.svg'

  export default {
    name: 'tech-city-social',
    props: {
      socialItems: {
        type: Object,
        required: true,
      },
      companyUrl: {
        type: Object,
      },
    },
    components: {
      SvgLinkIcon,
    },
    computed: {
      showChannel() {
        // once true, all true
        return reduce(this.socialItems, (result, val) => result || get(val, 'url'), false)
      },
    },
  }
</script>
<style scoped lang="scss">
  .social-title {
    margin: rem-calc(11 0);
  }
  a {
    display: inline-block;
    width: rem-calc(16);
    height: rem-calc(16);
    margin-right: rem-calc(25);


    @include respond-to("hd") {
      width: rem-calc(21);
      height: rem-calc(21);
      margin-right: rem-calc(27);
    }

    @include respond-to("mobile") {
      width: rem-calc(21);
      height: rem-calc(21);
      margin-right: rem-calc(27);
    }

    @media (min-width: 1254px) and (max-width: 1300px) {
      margin-right: rem-calc(20);
    }

    @media (min-width: 359px) and (max-width: 395px), (min-width: 1024px) and (max-width: 1253px) {
      margin-right: rem-calc(15);
    }

    @media (max-width: 358px) {
      margin-right: rem-calc(10);
    }

    &.company-url {
      max-width: rem-calc(210);
      width: rem-calc(210);
      height: rem-calc(21);
      border-radius: rem-calc(11);
      background-color: $white;
      text-align: center;
      margin-right: 0;
      display: inline-block;
      color: $timeline-dark-gray;
      line-height: rem-calc(21);
      text-decoration: none;
      font-size: rem-calc(14);
      padding: 0 rem-calc(10);
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      margin-bottom: rem-calc(-7);
      line-height: rem-calc(21);

      @include respond-to("desktop") {
        height: rem-calc(22);
        font-size: rem-calc(14);
        max-width: rem-calc(180);
        width: rem-calc(180);
        line-height: rem-calc(22);
      }

      @media (max-width: 342px) {
        width: rem-calc(180);
      }

      @media (min-width: 1024px) and (max-width: 1208px) {
        font-size: rem-calc(12);
        width: rem-calc(138);
      }

      &:hover {
        text-decoration: underline;
      }

      .icon {
        display: inline-block;
        width: rem-calc(12);
        height: rem-calc(12);
        fill: $timeline-dark-gray;
        margin-right: rem-calc(4);
        margin-bottom: rem-calc(-1);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// components/tech-city/overlay/TechCitySocial.vue